import ImageUrlConverter from "../util/ImageLinkConverter";
import { TeamMember } from "../types/TeamMember";

const YtechTeam:(TeamMember | undefined)[] = [
{
    name: "Edwina Mistry",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1fZ80iMyl6R7nq03XpKaoqjsPpatm4enr/view?usp=sharing"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1REm0KbN98pIkl072CId50cDbl0b4RUYt/view?usp=sharing"),
    title: "YTech Founder",
 },
 {
    name: "Max Dang Vu",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1mNACh0xrCaqoRjQPTrgEWhk1JVik5sSP/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/13AbwSRXlwKp5YK2_lRVqUdtnLiDb8jaq/view?usp=share_link"),
    title: "YTech Co-Founder",
 },
 {
    name: "John Chen",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1hP44Z7DlJOTTatNmIzgTDiY23U_oaT01/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1whtpsBgEUAl2Z73chH3cRwP7-LxYEREr/view?usp=share_link"),
    title: "YTech Co-Founder",
 },
 {
    name: "Aimee Lin",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1mOcPyD_BMSIRdHrUlReuQrLCL5dnhU-g/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1U8KTeeoZjfzN-tzALr6YZ79C3wfd6z4f/view?usp=share_link"),
    title: "Operations Team Lead",
 },
 {
    name: "Tia Durovich",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1obsrZf-CbeFe7zFZy54WGcuH9zkgKOUa/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1O_bqNuPuzsav5BgnlnQ-ff3ikzNHcGdl/view?usp=share_link"),
    title: "Design Team Lead",
 },
 {
    name: "Kenneth Zhu",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1x4zIyaaCglfUtNe5LFK4xhCLE6ZsDrvy/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1mrC5QexIsPheycxozkldKHkPUbHrAgDL/view?usp=share_link"),
    title: "Communications Team Lead",
 },
 {
    name: "Gauri Saxena",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1GWZ3KjbCT8e2IlRSbTfuo99Xh2glVsHR/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1R1-Pl6icQCHQQkBQQu4m7z57UPSsyVEY/view?usp=share_link"),
    title: "Operations & Communications",
 },
 {
    name: "Simran Naicker",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/12RZx00LMCf-Ob8m-sHMPwC6-X0k8UDLi/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/11eZYlA3c2n9unp6cjskc3yyuCj4OIoXN/view?usp=share_link"),
    title: "Operations & Marketing",
 },
 {
    name: "Jack Gong",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/19BHpnuCtsIMAmuLFH1BVPED-G_EVEmev/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1_W8Sto8gOiZCAyw0dv2HEeFP3lbA9Nsm/view?usp=share_link"),
    title: "Marketing & Design",
 },
 {
    name: "Durresameen Khan",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/161nuR8E5TGRAWvEGYWVMsxtZSWqznUCx/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1Oa3M8jNjM-cThag4Y-LcLRPd3y6C_bqT/view?usp=share_link"),
    title: "Design & Communications",
 },
 {
    name: "Lia Arroyo",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1mIWWv9IbCaW0vVIBfRGiRufVZMtr-Rx-/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1fZ8agBdCCBdx_Fx_en3VsRjeq4NCWO8E/view?usp=share_link"),
    title: "Marketing Team Lead",
 },
 {
    name: "Diya Patel",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/13_wltU2CtZay2r9Ax1ywtwITb5mE_5r3/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1-WcRzWr3hcKEapcHyxRWbcANNknAUu8g/view?usp=share_link"),
    title: "Operations & Marketing",
 },
 {
    name: "Liz Kuschel Young",
    circlePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1Q99gDeMGVC4jjqUCbL8tz1uNBUHnDlak/view?usp=share_link"),
    squarePhotoUrl: ImageUrlConverter("https://drive.google.com/file/d/1SaK1LDhx7oo64ARdeji9JY07Adw-g_n2/view?usp=sharing"),
    title: "Design",
 }
];

export default YtechTeam;